var _g, _path, _path2, _g2, _circle, _circle2, _circle3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterMeter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 102,
    viewBox: "0 0 101 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4287_16899)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 46.5,
    r: 46.5,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 47C94 72.6812 73.1812 93.5 47.5 93.5C21.8188 93.5 1 72.6812 1 47C1 47 21.8188 47.0001 47.5 47.0001C73.1812 47.0001 94 47 94 47Z",
    fill: "#0FDFF2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94 46.999C94 49.7604 85.5 58 47.5 58C7.5 58 1 49.7611 1 46.9996C1 46.9996 21.8188 46.999 47.5 46.999C87 46.999 94 46.999 94 46.999Z",
    fill: "#7ED0D5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4287_16899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1143 57.2486C35.8596 57.2486 34.741 57.0178 33.7585 56.5561C32.782 56.0945 32.0066 55.4582 31.4325 54.6474C30.8584 53.8365 30.5595 52.9073 30.5359 51.8597H34.2646C34.306 52.564 34.6019 53.1352 35.1523 53.5732C35.7028 54.0111 36.3568 54.2301 37.1143 54.2301C37.718 54.2301 38.2507 54.0969 38.7124 53.8306C39.1799 53.5584 39.5439 53.1825 39.8043 52.7031C40.0707 52.2178 40.2038 51.6615 40.2038 51.0341C40.2038 50.3949 40.0677 49.8326 39.7955 49.3473C39.5291 48.862 39.1592 48.4832 38.6857 48.2109C38.2122 47.9387 37.6707 47.7996 37.0611 47.7937C36.5284 47.7937 36.0105 47.9032 35.5075 48.1222C35.0103 48.3411 34.6226 48.64 34.3445 49.0188L30.9265 48.4062L31.7876 38.8182H42.9027V41.9609H34.957L34.4865 46.5153H34.593C34.9126 46.0655 35.395 45.6926 36.0401 45.3967C36.6853 45.1007 37.4073 44.9528 38.2063 44.9528C39.3013 44.9528 40.2778 45.2102 41.136 45.7251C41.9942 46.2401 42.6719 46.9473 43.169 47.8469C43.6662 48.7406 43.9118 49.7705 43.9059 50.9364C43.9118 52.1616 43.6277 53.2506 43.0536 54.2035C42.4854 55.1504 41.6894 55.8962 40.6655 56.4407C39.6475 56.9793 38.4638 57.2486 37.1143 57.2486ZM53.7159 57.3995C52.1889 57.3936 50.875 57.0178 49.7741 56.272C48.6792 55.5263 47.8358 54.4461 47.244 53.0316C46.658 51.6171 46.368 49.9155 46.3739 47.9268C46.3739 45.9441 46.6669 44.2544 47.2528 42.8576C47.8447 41.4608 48.6881 40.3984 49.783 39.6705C50.8839 38.9366 52.1948 38.5696 53.7159 38.5696C55.237 38.5696 56.545 38.9366 57.6399 39.6705C58.7408 40.4044 59.5871 41.4697 60.179 42.8665C60.7708 44.2573 61.0638 45.9441 61.0579 47.9268C61.0579 49.9214 60.762 51.6259 60.1701 53.0405C59.5842 54.455 58.7437 55.5352 57.6488 56.2809C56.5539 57.0266 55.2429 57.3995 53.7159 57.3995ZM53.7159 54.2124C54.7576 54.2124 55.5891 53.6886 56.2106 52.641C56.832 51.5934 57.1398 50.022 57.1339 47.9268C57.1339 46.5478 56.9918 45.3996 56.7077 44.4822C56.4296 43.5649 56.033 42.8754 55.5181 42.4137C55.0091 41.9521 54.4084 41.7212 53.7159 41.7212C52.6802 41.7212 51.8516 42.2391 51.2301 43.2749C50.6087 44.3106 50.295 45.8613 50.2891 47.9268C50.2891 49.3236 50.4281 50.4896 50.7063 51.4247C50.9904 52.3539 51.3899 53.0523 51.9048 53.5199C52.4197 53.9815 53.0234 54.2124 53.7159 54.2124ZM70.5518 54.5455V53.8551C70.5518 53.331 70.6626 52.8494 70.8841 52.4105C71.11 51.9673 71.436 51.6136 71.8621 51.3494C72.2925 51.081 72.8167 50.9467 73.4346 50.9467C74.061 50.9467 74.5873 51.0788 75.0134 51.343C75.4438 51.6072 75.7677 51.9609 75.985 52.4041C76.2066 52.843 76.3174 53.3267 76.3174 53.8551V54.5455C76.3174 55.0696 76.2066 55.5533 75.985 55.9964C75.7634 56.4354 75.4374 56.7869 75.007 57.0511C74.5766 57.3196 74.0525 57.4538 73.4346 57.4538C72.8082 57.4538 72.2819 57.3196 71.8557 57.0511C71.4296 56.7869 71.1057 56.4354 70.8841 55.9964C70.6626 55.5533 70.5518 55.0696 70.5518 54.5455ZM72.4118 53.8551V54.5455C72.4118 54.848 72.4843 55.1335 72.6292 55.402C72.7783 55.6705 73.0468 55.8047 73.4346 55.8047C73.8224 55.8047 74.0866 55.6726 74.2272 55.4084C74.3721 55.1442 74.4445 54.8565 74.4445 54.5455V53.8551C74.4445 53.544 74.3763 53.2543 74.24 52.9858C74.1036 52.7173 73.8351 52.5831 73.4346 52.5831C73.051 52.5831 72.7847 52.7173 72.6356 52.9858C72.4864 53.2543 72.4118 53.544 72.4118 53.8551ZM63.8337 47.054V46.3636C63.8337 45.8352 63.9466 45.3516 64.1725 44.9126C64.3983 44.4695 64.7243 44.1158 65.1505 43.8516C65.5809 43.5874 66.1008 43.4553 66.7101 43.4553C67.3408 43.4553 67.8692 43.5874 68.2954 43.8516C68.7215 44.1158 69.0454 44.4695 69.267 44.9126C69.4885 45.3516 69.5993 45.8352 69.5993 46.3636V47.054C69.5993 47.5824 69.4864 48.0661 69.2606 48.505C69.039 48.9439 68.713 49.2955 68.2826 49.5597C67.8564 49.8196 67.3323 49.9496 66.7101 49.9496C66.088 49.9496 65.5617 49.8175 65.1313 49.5533C64.7052 49.2848 64.3813 48.9332 64.1597 48.4986C63.9424 48.0597 63.8337 47.5781 63.8337 47.054ZM65.7066 46.3636V47.054C65.7066 47.3651 65.779 47.6527 65.9239 47.9169C66.0731 48.1811 66.3351 48.3132 66.7101 48.3132C67.1022 48.3132 67.3685 48.1811 67.5091 47.9169C67.654 47.6527 67.7265 47.3651 67.7265 47.054V46.3636C67.7265 46.0526 67.6583 45.7628 67.5219 45.4943C67.3856 45.2259 67.115 45.0916 66.7101 45.0916C66.3309 45.0916 66.0688 45.228 65.9239 45.5007C65.779 45.7734 65.7066 46.0611 65.7066 46.3636ZM64.6775 57L73.6775 43.9091H75.3522L66.3522 57H64.6775Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 86.5,
    r: 2.5,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.8
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 77,
    r: 4,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 67,
    r: 6,
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4287_16899",
    x: 0,
    y: 0,
    width: 101,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.505882 0 0 0 0 0.447059 0 0 0 0 0.160784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4287_16899"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4287_16899",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4287_16899",
    x: 14.5352,
    y: 26.5693,
    width: 77.7812,
    height: 50.8848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4287_16899"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4287_16899",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterMeter);
export default __webpack_public_path__ + "static/media/water_meter.8c4d1bd57127457539a86364f104fcc1.svg";
export { ForwardRef as ReactComponent };